export function stripTrailingZeros(value: string): string {
  if (!value.includes(".")) return value
  return value.replace(/\.?0+$/, "")
}

export function formatCount(value: number | string): string {
  return Math.round(Number(value)).toLocaleString("en-US")
}

export function formatDecimal(
  value: number | string,
  maxFractionDigits: number,
): string {
  return Number(value).toLocaleString("en-US", {
    maximumFractionDigits: maxFractionDigits,
  })
}

export function formatFixed(
  value: number | string,
  fractionDigits: number,
): string {
  return Number(value).toLocaleString("en-US", {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  })
}

export function formatHours(hours: number): string {
  return formatDecimal(hours, 2)
}

export function toHoursInputValue(hours: number): string {
  return stripTrailingZeros(hours.toFixed(2))
}

export function formatFlightHours(hours: number | string): string {
  return formatFixed(hours, 1)
}

export function formatHoursMinutes(minutes: number): string {
  const whole = formatCount(Math.floor(minutes / 60))
  return `${whole}:${String(minutes % 60).padStart(2, "0")}`
}

export function formatMinutes(minutes: number): string {
  const hours = Math.floor(minutes / 60)
  return hours
    ? `${hours}h ${String(minutes % 60).padStart(2, "0")}m`
    : `${minutes}m`
}

export function formatClock(seconds: number): string {
  const whole = Math.floor(seconds)
  const minutes = String(Math.floor(whole / 60) % 60).padStart(2, "0")
  return `${Math.floor(whole / 3600)}:${minutes}:${String(whole % 60).padStart(2, "0")}`
}

export function formatPercent(ratio: number, fractionDigits = 0): string {
  return `${formatFixed(ratio * 100, fractionDigits)}%`
}

export function toNumberOrNull(value: string | null): number | null {
  if (value === null || value === "") return null
  const parsed = Number.parseFloat(value)
  return Number.isNaN(parsed) ? null : parsed
}
